import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import constant from "../constant";
import { useCurrentWorkingVessel } from "./useCurrentWorkingVessel";
import { useCrewProfile } from "../hooks/useCrewProfile";

export const VESSEL_SELECTED_EVENT = "vi:vessel-selected";

/** Vessel from header dropdown (localStorage). */
export const getStoredSelectedVessel = () => {
    try {
        const saved = localStorage.getItem(constant.keys.selectedVessel);
        if (!saved) return null;
        const v = JSON.parse(saved);
        const vessel_id = v.value ?? v.vessel_id ?? v.id;
        const vessel_name = v.label ?? v.vessel_name ?? v.name;
        if (!vessel_id) return null;
        return {
            vessel_id: Number(vessel_id),
            vessel_name: vessel_name || "",
            vessel_code: v.vessel_code,
        };
    } catch {
        return null;
    }
};

/**
 * Resolve the active vessel: route state → crew assignment → header selection.
 */
export const useResolvedVessel = () => {
    const location = useLocation();
    const { data: locationData } = location.state || {};
    const { vessel: currentVessel, loading } = useCurrentWorkingVessel();
    const { isCrewProfile } = useCrewProfile();
    const [storedVesselTick, setStoredVesselTick] = useState(0);

    useEffect(() => {
        const onVesselSelected = () => setStoredVesselTick((n) => n + 1);
        window.addEventListener(VESSEL_SELECTED_EVENT, onVesselSelected);
        return () => window.removeEventListener(VESSEL_SELECTED_EVENT, onVesselSelected);
    }, []);

    const vessel = useMemo(() => {
        if (locationData?.vessel_id) return locationData;
        if (location.state?.vessel_id && locationData) {
            return { ...locationData, vessel_id: location.state.vessel_id };
        }
        if (currentVessel?.vessel_id) return currentVessel;
        // Crew must never use office vessel picker cache — causes vessel-scope 403s.
        if (isCrewProfile || loading) return null;
        return getStoredSelectedVessel();
        // storedVesselTick re-reads header vessel selection without a full navigation.
    }, [locationData, location.state, currentVessel, isCrewProfile, loading, storedVesselTick]);

    return { vessel, loading };
};
